var render = function render(){var _vm=this,_c=_vm._self._c;return _c('copyable-field',{staticClass:"sub-block",attrs:{"is-loading":_vm.isLoading,"name":_vm.__('Reference'),"value":_vm.reference}})
}
var staticRenderFns = []

export { render, staticRenderFns }